let shareSNS = {
	nav: function(){
		let $this;
		//share
		$(".block_share dd a").off().on("click", function(){
			$this = $(this);
			var type 	= $(this).attr("data-type");
			var url 	= $(this).attr("data-url");
			shareTxt(type, url);
		});
		function shareTxt(type, shareUrl){
			var url 	= shareUrl;
			console.log(type, url);
			if(type === "facebook"){
				//Facebook
				window.open(
					'http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
					'facebooksharedialog',
					'width=626,height=436');
			}else if(type === "twitter"){
				//Twitter
				window.open(
					'http://twitter.com/share?url=' + encodeURIComponent(url),
					'twittersharedialog',
					'width=626,height=436');
			}
		}
	}
}